import { useEffect } from 'react';
import { Page, Header, Content, Progress } from '@backstage/core-components';
import { identityApiRef, useApi } from '@backstage/core-plugin-api';

const LogoutPage = () => {
  const identityApi = useApi(identityApiRef);

  useEffect(() => {
    // Triggers a full page reload after clearing the Backstage session.
    // The reload will keep the current path (/logout), after which our
    // SignInPage override will render a non-auto login screen.
    try {
      // Mark that we're intentionally logging out so the SignInPage
      // disables auto sign-in on the next load even if the path changes.
      window.sessionStorage.setItem('disableAutoSignInOnce', 'true');
    } catch {
      // ignore storage errors (e.g., disabled cookies)
    }
    void identityApi.signOut();
  }, [identityApi]);

  return (
    <Page themeId="tool">
      <Header title="Signing you out..." />
      <Content>
        <Progress />
      </Content>
    </Page>
  );
};

export default LogoutPage;
